<!-- <mat-slider
  fxFlex
  color="primary"
  [max]="maxValue"
  [min]="minValue"
  [step]="1"
  [value]="control.value"
  [thumbLabel]="false"
  [tickInterval]="1"
  (change)="onSliderChange($event)"
></mat-slider> -->

<mat-slider fxFlex color="accent" step="1" [min]="minValue" [max]="maxValue" showTickMarks>
  <input [value]="control.value" (valueChange)="onSliderChange($event)" matSliderThumb />
</mat-slider>
